module.exports = __webpack_public_path__ + "static/media/trans-reservations.a9d06a43.svg";